module.exports = __webpack_public_path__ + "img/web_logo.f822e3ec.png";